<template>
  <div>
    <MasterLayout>
      <div class="fuelbalance_first_row">
        <div
          class="card_container"
          style="border-radius: 17px"
          :style="{
            backgroundImage: `url(${cardBackgroundUrl})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'right',
            backgroundSize: ' 136px',
          }"
        >
          <div class="card__header___text">
            <div>
              <h3 class="our_branches__header">
                {{ $t("text.bankAccounts.noOfBankAccounts") }}
              </h3>
              <div class="dealer__icon__wrapper mt-3">
                <div class="dealer__icon__div text-center showAllContainer">
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20.966"
                      height="21.393"
                      viewBox="0 0 20.966 21.393"
                    >
                      <g id="surface1" transform="translate(-0.089 -0.001)">
                        <path
                          id="Path_2471"
                          data-name="Path 2471"
                          d="M.482,5.91a.866.866,0,0,0-.014.128v.88a.872.872,0,0,0,.566.814V9.028a.814.814,0,0,0,.775.81v7.481a.814.814,0,0,0-.775.81V19.42a.882.882,0,0,0-.566.822V21.1a.291.291,0,0,0,.291.291H20.37a.291.291,0,0,0,.291-.291v-.861a.882.882,0,0,0-.566-.822v-1.3a.814.814,0,0,0-.775-.81V9.838a.814.814,0,0,0,.775-.81V7.733a.873.873,0,0,0,.566-.814V6.044a.845.845,0,0,0-.014-.128.289.289,0,0,0,.235-.529L10.7.035a.291.291,0,0,0-.271,0L.244,5.381a.291.291,0,0,0,.238.529ZM1.617,8.237V7.789H4.97v.444Zm7.467,1.6v7.479a.814.814,0,0,0-.775.81v1.237H5.548V18.129a.814.814,0,0,0-.775-.81V9.838a.814.814,0,0,0,.775-.81V7.789H8.3V9.026a.814.814,0,0,0,.776.812Zm-.194-1.6V7.789h3.354v.444Zm7.468,1.6v7.479a.814.814,0,0,0-.776.81v1.237h-2.76V18.129a.814.814,0,0,0-.775-.81V9.838a.814.814,0,0,0,.775-.81V7.789h2.757V9.026a.814.814,0,0,0,.775.812Zm-.194-1.6V7.789h3.354v.444Zm3.354,10.686v.444H16.16v-.444Zm-7.274,0v.444H8.886v-.444ZM9.371,9.262H9.119a.233.233,0,0,1-.233-.233V8.818H12.24V9.03a.233.233,0,0,1-.233.233Zm2.1.582v7.471h-1.8V9.844ZM9.371,17.9h2.637a.233.233,0,0,1,.233.233v.211H8.886v-.211a.233.233,0,0,1,.233-.233Zm-4.4,1.026v.444H1.613v-.444ZM1.613,9.035V8.818H4.966V9.03a.233.233,0,0,1-.233.233H1.839a.233.233,0,0,1-.227-.235Zm2.578.814v7.466h-1.8V9.844ZM1.613,18.135a.233.233,0,0,1,.233-.233H4.734a.233.233,0,0,1,.233.233v.211H1.613ZM20.08,20.254v.57H1.047v-.57a.3.3,0,0,1,.3-.3H19.779a.3.3,0,0,1,.3.295Zm-.566-2.119v.211H16.16v-.211a.233.233,0,0,1,.233-.233h2.894a.233.233,0,0,1,.227.227Zm-2.578-.814V9.844h1.8v7.471Zm2.578-8.285a.233.233,0,0,1-.233.233H16.394a.233.233,0,0,1-.233-.233V8.818h3.354ZM10.563.616l8.66,4.552H1.9ZM1.047,6.044a.291.291,0,0,1,.291-.291H19.789a.291.291,0,0,1,.291.291v.88a.291.291,0,0,1-.291.291H1.337a.291.291,0,0,1-.291-.291Zm0,0"
                          transform="translate(0)"
                          fill="white"
                        />
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="text-center mt-3">
                <h3>{{ bankCount }}</h3>
              </div>
            </div>
          </div>
        </div>
        <div
          class="fuelbalance_first_row_right_section mr-3"
          style="border-radius: 22px"
        >
          <div class="our__branches__banner">
            <div class="row align-items-center section__row">
              <div class="col-md-4">
                <div class="input__group__block" style="width: 90%">
                  <label class="required" style="color: white">
                    <span>
                      <img src="@/assets/img/user1.png" width="25px" />
                    </span>
                    {{ $t("text.bankAccounts.bankName") }}
                  </label>
                  <div class="input__block">
                    <select v-model="bankName">
                      <option value="" disabled selected hidden>
                        {{ $t("text.bankAccounts.selectBankName") }}
                      </option>
                      <option
                        v-for="(bank, index) in bankNames"
                        :key="index"
                        v-bind:value="bank.bankName"
                      >
                        {{ bank.bankName }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="input__group__block" style="width: 90%">
                  <label class="required" style="color: white">
                    <span>
                      <img src="@/assets/img/user1.png" width="25px" />
                    </span>
                    {{ $t("text.bankAccounts.accountNumber") }}
                  </label>
                  <div class="input__block" ref="account_number_input_div">
                    <input
                      v-model="accountNumber"
                      type="text"
                      :placeholder="$t('text.bankAccounts.inputAccountNumber')"
                      class="form-control"
                      @blur="captureFormEvents($event)"
                    />
                  </div>
                  <div ref="account_number_error"></div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="input__group__block" style="width: 90%">
                  <label class="required" style="color: white">
                    <span>
                      <img src="@/assets/img/user1.png" width="25px" />
                    </span>
                    {{ $t("text.bankAccounts.accountName") }}
                  </label>
                  <div class="input__block" ref="account_name_input_div">
                    <input
                      v-model="accountName"
                      type="text"
                      :placeholder="$t('text.bankAccounts.inputAccountName')"
                      class="form-control"
                      @blur="captureFormEvents($event)"
                    />
                  </div>
                  <div ref="account_name_error"></div>
                </div>
              </div>
              <div class="save__btn_div" style="margin: 0 auto; width: 20%">
                <button class="ep-btn ep-primary" @click="addBankAccts">
                  {{ $t("text.bankAccounts.save") }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="products_summary__wrapper mt-3 pb-3">
        <div class="">
          <div class="ep-card green-color p-1 text-center br-5">
            <p class="m-0 primary-color">
              <span class="mr-3">
                <img src="@/assets/img/link.svg" width="25" />
              </span>
              {{ $t("text.bankAccounts.iconInfo") }}
            </p>
          </div>
        </div>
        <div class="row ml-2">
          <div class="col-md-4" v-for="acc in banks" :key="acc.id">
            <div class="linked-account-wrapper">
              <div class="linked-acounts-container position-relative">
                <div class="position-absolute">
                  <div class="linked-icon-container" v-if="acc.linked">
                    <img src="@/assets/img/link.svg" width="25" />
                  </div>
                </div>
                <div class="d-flex justify-content-between mt-5 pt-3">
                  <span class="font-600 primary-color">
                    {{ acc.name }}
                  </span>
                  <!-- <img src="@/assets/img/bank-building (2).svg" width="25" /> -->
                  <p class="primary-color m-0 font-600">
                    {{ acc.accountName }}
                  </p>
                </div>
                <div class="d-flex justify-content-between mt-4">
                  <p class="font-600 primary-color">{{ acc.accountNumber }}</p>
                  <!-- <p class="">Remove bank</p> -->
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="">
              <div class="linked-account-muted">
                <div class="mx-auto text-center">
                  <img src="@/assets/img/bank-disabled.svg" width="25" />
                  <p class="text-muted mt-3">
                    {{ $t("text.bankAccounts.accountsAdded") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        class="products_summary__wrapper pb-3"
        v-if="bankCount < 1 && !showLoader"
      >
        <div
          class="empty_tank_wrapper"
          style="
            height: 400px;
            background: white;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-flow: column wrap;
          "
        >
          <div class="text-center" style="margin-top: 60px">
            <h3 style="color: rgb(161, 146, 146); font-size: 25px">
              {{ $t("text.bBankAccounts.emptyBankRecord") }}
            </h3>
          </div>

          <div class="text-center mt-5">
            <!-- <img src="@/assets/img/target (1) (1).svg"  width="100"  /> -->
          </div>

          <!-- <div class="text-cente pb-5" style="margin-top: 50px">
                  <h3  style="color: rgb(161, 146, 146); font-size: 25px;">You currently don't have any target record</h3>
              </div> -->
        </div>
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import MasterLayout from "@/views/Company/MasterLayout.vue";
import backgroundUrl from "@/assets/img/BecomeDealer.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "BankAccounts",
  title: `Bank Accounts:: Epump Portal`,
  components: {
    MasterLayout,
  },
  data() {
    return {
      banks: [],
      bankNames: [],
      backgroundUrl,
      cardBackgroundUrl,
      showLoader: false,
      bankCount: 0,
      bankName: "",
      accountNumber: "",
      accountName: "",
      company: null,
    };
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getBanks();
        this.getBankAccts();
      }
    },
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if (this.$route.query.companyId) {
      this.getBanks();
      this.getBankAccts();
    }
  },
  mounted() {},
  methods: {
    captureFormEvents($event) {
      if (
        $event.target.placeholder ===
        this.$t("text.bankAccounts.inputAccountName")
      ) {
        if ($event.target.value === "") {
          this.$refs.account_name_error.style.display = "block";
          // this.$refs.account_name_error.innerHTML =
          //   this.$t('text.errors.accountNameMissing');
          this.$refs.account_name_input_div.style.border = "1px solid red";
          this.$refs.account_name_error.style.color = "red";
          this.formIsValid = false;
        } else {
          this.$refs.account_name_error.style.display = "none";
          this.$refs.account_name_error.innerHTML = "";
          this.$refs.account_name_input_div.style.border =
            "1px solid rgb(75, 44, 114)";
          this.formIsValid = false;
        }
      }
      if (
        $event.target.placeholder ===
        this.$t("text.bankAccounts.inputAccountNumber")
      ) {
        if ($event.target.value === "") {
          this.$refs.account_number_error.style.display = "block";
          // this.$refs.account_number_error.innerHTML =
          //   this.$t('text.errors.accountNumberMissing');
          this.$refs.account_number_input_div.style.border = "1px solid red";
          this.$refs.account_number_error.style.color = "red";
          this.formIsValid = false;
        } else {
          this.$refs.account_number_error.style.display = "none";
          this.$refs.account_number_error.innerHTML = "";
          this.$refs.account_number_input_div.style.border =
            "1px solid rgb(75, 44, 114)";
          this.formIsValid = false;
        }
      }
    },
    getBanks() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/Banks&companyId=${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          this.bankNames = response.data;
        })
        .catch((error) => {});
    },
    getBankAccts() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/BankAccounts/${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then((response) => {
          this.banks = response.data;
          this.bankCount = response.data.length;
        })
        .catch((error) => {});
    },
    addBankAccts() {
      if (!this.bankName) {
        this.$toast.open({
          message: this.$t("text.bankAccounts.selectBankError"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.accountNumber) {
        this.$toast.open({
          message: this.$t("text.errors.accountNumberMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      if (!this.accountName) {
        this.$toast.open({
          message: this.$t("text.errors.accountNameMissing"),
          type: "error",
          duration: 5000,
        });
        return;
      }
      let data = {
        bankName: this.bankName,
        accountNumber: this.accountNumber,
        accountName: this.accountName,
        companyId: this.$route.query.companyId
          ? this.$route.query.companyId
          : this.company.id,
      };

      this.axios
        .post(
          `${configObject.apiBaseUrl}/Company/AddBankAccount`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.getBankAccts();
          this.$toast.open({
            message: this.$t("text.bankAccounts.bankAdded"),
            type: "success",
            duration: 5000,
          });
          this.accountNumber = "";
          this.accountName = "";
        })
        .catch((error) => {});
    },
    deleteBankAcct(id) {
      const remove = confirm(this.$t("text.bankAccounts.confirmDelete"));
      if (!remove) {
        return;
      }
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/RemoveBankAccount/${id}?branchId=${
            this.$route.query.companyId
              ? this.$route.query.companyId
              : this.company.id
          }`,
          configObject.authConfig()
        )
        .then(() => {
          this.$toast.open({
            message: this.$t("text.bankAccounts.successfullyDeleted"),
            type: "success",
            duration: 5000,
          });
          this.getBankAccts();
        })
        .catch(() => {
          this.$toast.open({
            message: this.$t("text.bankAccounts.unsuccessfulDelete"),
            type: "error",
            duration: 5000,
          });
        });
    },
  },
};
</script>
